module.exports = "/dist/assets/images/noImage.png";